import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";
import config from "../configs/config";
import { useMsal } from "@azure/msal-react";
import { updateFavicon, updatePageTitle } from "../utils/favicon";
import "./styles/Login.css";

function Login() {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const { login, user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const organization = user?.user?.organization;
    if (organization) {
      if (organization.favicon_url) {
        updateFavicon(organization.favicon_url);
      }
      if (organization.name) {
        updatePageTitle(organization.name, "Login");
      }
    }
  }, [user?.user?.organization]);

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const loginResponse = await instance.loginPopup();
      if (loginResponse) {
        const response = await axios.post(
          `${config.API_BASE_URL}/loginOffice`,
          {
            id_token: loginResponse.idToken,
          },
          {
            withCredentials: true,
            timeout: 30000,
          }
        );

        if (response.status === 200) {
          const data = response.data;

          const organization = data.user?.organization;
          if (organization) {
            if (organization.favicon_url) {
              updateFavicon(organization.favicon_url);
            }
            if (organization.name) {
              updatePageTitle(organization.name);
            }
          }

          login(data);
          navigate("/home");
        } else {
          console.error("Failed to fetch user data");
        }
      }
    } catch (error) {
      console.error("Login failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* Animated background gradient */}
      <div className="gradient-bg"></div>

      {/* Floating shapes */}
      <div className="shape shape-1"></div>
      <div className="shape shape-2"></div>
      <div className="shape shape-3"></div>

      {/* Main content */}
      <div className="login-content">
        <div className="login-card">
          {/* Logo/Brand section */}
          <div className="brand-section">
            <h1 className="brand-title">Welcome Back</h1>
            <p className="brand-subtitle">
              Sign in to continue to your account
            </p>
          </div>

          {/* Login button */}
          <button
            className={`login-button ${isLoading ? "loading" : ""}`}
            onClick={handleLogin}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner"></span>
                Signing in...
              </>
            ) : (
              <>
                Log in
              </>
            )}
          </button>

        </div>
      </div>
    </div>
  );
}

export default Login;
